// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 425) return "static/chunks/425-2b93f7aef4ca2953.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 225 ? "e78b34b7" : chunkId) + "." + {"38":"0ab198ed17c7b250","50":"ce6b84cb5597fcaa","213":"9b2ff62a83f5dbbc","225":"3cbdbda481c33895","238":"4731607717e11662","258":"8ae536c73e3b4ac8","347":"908dde1852dc56e7","457":"f83f9a7e804ab404","579":"f2b8d11af8fa6469","972":"97fb542c09ad4295"}[chunkId] + ".js";
};